import Api from "../ApiUtility/Api";


class LogsDS {
  constructor() {
    this.api = new Api();
  }

  //LOGIN POST

  RM_Activity_Logs_INSERT(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Activity_Logs_INSERT')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  RM_Activity_Logs_GET(requestData) {
    return this.api.postAPI(requestData, '/dev/WS_Activity_Logs_GET')
      .then(data => {
        console.log("parsed data", data)
        return data;
      })
      .catch(error => {
        console.error('Error during User Authentication API call :', error);
        throw error;
      });
  }
  // RM_Activity_Logs_ByID_Get(requestData) {
  //   return this.api.postAPI(requestData, '/dev/RM_Activity_Logs_ByID_Get')
  //     .then(data => {
  //       console.log("parsed data", data)
  //       return data;
  //     })
  //     .catch(error => {
  //       console.error('Error during User Authentication API call :', error);
  //       throw error;
  //     });
  // }

}

export default LogsDS;